<template>
  <div>
    <div>
      <b-container class="bv-example-row">
        <div class="my-15 container card_container">
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px"><strong>Nome</strong></div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="nome"
                  placeholder="Nome"
                  :value="jsonData.assistito.nome"
                  style="text-transform: uppercase"
                  disabled
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Cognome</strong>
              </div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="cognome"
                  placeholder="Cognome"
                  :value="jsonData.assistito.cognome"
                  style="text-transform: uppercase"
                  disabled
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Codice fiscale</strong>
              </div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="cf"
                  placeholder="Codice Fiscale"
                  :value="jsonData.assistito.codiceFiscale"
                  style="text-transform: uppercase"
                  disabled
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px"><strong>Data di nascita</strong></div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="datanascita"
                  placeholder="Data di nascita"
                  :value="jsonData.assistito.dataNascita"
                  locale="it"
                  disabled
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Luogo di nascita</strong>
              </div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="luogonascita"
                  :value="jsonData.assistito.luogoDiNascita"
                  style="text-transform: uppercase"
                  disabled
              />
            </b-col>
          </b-row>

          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Sesso</strong>
              </div>
              <b-form-select class="form-select" :value="jsonData.assistito.sesso" :options="sessoOptions"
                             disabled></b-form-select>
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Stato civile</strong>
              </div>
              <b-form-select class="form-select" v-model="jsonData.assistito.statoCivile" :options="statoCivileOptions"
                             :value="null"></b-form-select>
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Provincia di residenza</strong>
              </div>
              <b-form-select
                  class="form-select"
                  v-model="jsonData.assistito.residenza.provincia"
                  :options="provinciaResidenzaOptions"
                  :value="null"
                  value-field="value"
                  text-field="text"
                  @change="getSelectedProvinciaResidenza"
                  style="text-transform: uppercase"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong> Comune di residenza</strong>
              </div>
              <b-form-select
                  class="form-select"
                  v-model="jsonData.assistito.residenza.comune"
                  :value="null"
                  value-field="value"
                  :options="comuniResidenzaOptions"
                  text-field="text"
                  style="text-transform: uppercase"
              ></b-form-select>
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Indirizzo di residenza</strong>
              </div>
              <b-form-input
                  v-model="jsonData.assistito.indirizzoResidenza"
                  :value="null"
                  value-field="value"
                  text-field=""
                  style="text-transform: uppercase"
                  type="text"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Nazionalità</strong>
              </div>
              <b-form-select
                  class="form-select"
                  v-model="cittadinanzaScelta"
                  :options="cittadinanzaOptions"
                  value-field="value"
                  text-field="text"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Cellulare</strong>
              </div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="cellulare"
                  placeholder="Cellulare"
                  required
                  maxlength="10"
                  :state="validationCellulare"
                  :value="jsonData.assistito.numeroCellulare"
                  :disabled="true"
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Telefono fisso</strong>
              </div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="fisso"
                  placeholder="Telefono fisso"
                  value=""
                  required
                  maxlength="10"
                  :state="validationFisso"
                  v-model="jsonData.assistito.numeroFisso"
              />
            </b-col>
            <b-col sm class="mb-7 mt-5">
              <div class="h-35px">
                <strong>Email</strong>
              </div>
              <b-form-input
                  type="text"
                  class="form-control form-control-solid"
                  name="email"
                  placeholder="Email"
                  required
                  maxlength="10"
                  :state="validationEmail"
                  :value="jsonData.assistito.email"
                  :disabled="true"
              />
            </b-col>
          </b-row>
          <div class="footer d-flex justify-content-end">
            <b-button variant="light" class="text-primary" @click="onIndietro"
            ><i class="fas fa-angle-double-left"></i>
              Indietro
            </b-button>

            <b-button class="ml-2 btn-primary" @click="onModifica"><i class="fas fa-check"></i> Salva</b-button>
          </div>
        </div>
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots"
                 :height="120" :width="120"></loading>
      </b-container>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import UtilityMixin from "../../utilities/utilityMixin";
import UtilService from "@/services/utilService";
import AuthService from "@/services/authService";

export default {
  components: {Loading},
  mixins: [UtilityMixin],
  props: {
    assistito: Object,
  },
  data() {
    return {
      jsonData: {
        assistito: {
          nome: this.assistito.nome,
          cognome: this.assistito.cognome,
          statoCivile: {
            id: this.assistito.codStatoCivile,
            descrizione: this.assistito.statoCivile,
          },
          residenza: {
            provincia: {
              codIstat: this.assistito.codIstatProvinciaResidenza,
              provincia: this.assistito.provinciaResidenza,
            },
            comune: {
              cap: this.assistito.capResidenza,
              codice: this.assistito.codIstatComuneResidenza,
              nome: this.assistito.comuneResidenza,
              provinciaSigla: this.assistito.provinciaResidenzaSigla,
            },
          },
          codiceFiscale: this.assistito.codiceFiscale,
          dataNascita: this.assistito.dataNascita,
          luogoDiNascita: this.assistito.luogoDiNascita,
          sesso: this.assistito.sesso,
          indirizzoResidenza: this.assistito.indirizzoResidenza,
          numeroCellulare: this.assistito.numeroCellulare,
          numeroFisso: this.assistito.numeroFisso,
          email: this.assistito.email,
          cittadinanza: this.assistito.cittadinanza,
          istatCittadinanza: this.assistito.istatCittadinanza,
        },
      },
      sessoOptions: [
        {value: "M", text: "MASCHIO"},
        {value: "F", text: "FEMMINA"},
      ],
      provinciaResidenzaOptions: [
        {value: null, text: "Seleziona la Provincia", disabled: true},
        {
          value: {
            provincia: this.assistito.provinciaResidenza,
            codIstat: this.assistito.codIstatProvinciaResidenza,
          },
          text: this.assistito.provinciaResidenza.toUpperCase(),
        },
      ],
      cittadinanzaOptions: [{value: null, text: "Seleziona la cittadinanza", disabled: true},
        {
          text: this.assistito.cittadinanza,
          value: {
            text: this.assistito.cittadinanza,
            value: this.assistito.istatCittadinanza,
          },
        }],
      cittadinanzaScelta: {
        text: this.assistito.cittadinanza,
        value: this.assistito.istatCittadinanza,
      },
      comuniResidenzaOptions: [
        {value: null, text: "Seleziona il Comune", disabled: true},
        {
          value: {
            cap: this.assistito.capResidenza,
            codice: this.assistito.codIstatComuneResidenza,
            nome: this.assistito.comuneResidenza,
            provinciaSigla: this.assistito.provinciaResidenzaSigla,
          },
          text: this.assistito.comuneResidenza,
        },
      ],
      statoCivileOptions: [{value: null, text: "Seleziona Stato Civile", disabled: true}],
      pathResourceListaProvince: "/api/v2.0/appecupt/comuni/listaprovince",
      pathResourceStatoCivile: "/api/v2.0/appecupt/statocivile",
      pathResourceListaComuni: "/api/v2.0/appecupt/comuni/listacomuni",
      pathResourceListaNazioni: "/api/v2.0/appecupt/nazioni/",
      pathResourceModificaContatto: "/api/v2.0/appecupt/auth/modAssistito",
      token: null,
      nazionalitaStraniera: false,
      isLoading: false,
    };
  },
  computed: {
    validationCellulare() {
      var regexCellulare = /^3\d{8,9}$/;

      return regexCellulare.test(this.jsonData.assistito.numeroCellulare) ? true : false;
    },
    validationFisso() {
      let regexFisso = /^0\d+$/;
      return !this.jsonData.numeroFisso || this.jsonData.numeroFisso.length === 0 ? null : regexFisso.test(this.jsonData.numeroFisso) ? true : false;
    },
    validationEmail() {
      var regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return this.jsonData.assistito.email.length === 0 ? null : regexEmail.test(this.jsonData.assistito.email) ? true : false;
    },
  },
  mounted: function () {
    let me = this;
    me.token = sessionStorage.getItem("tokenWSO2");
    me.tokenLogin = sessionStorage.getItem("loginData");
    me.loadListaProvince();
    if (me.assistito.codIstatProvinciaResidenza) me.getSelectedProvinciaResidenza(null);
    me.loadStatoCivile();
    me.controlloNazionalita();
  },
  methods: {
    async loadListaProvince() {
      let me = this;
      try {
        const responseProvince = await UtilService.listaProvince();
        responseProvince.data.data.forEach((element) => {
          me.provinciaResidenzaOptions.push({
            value: element,
            text: element.provincia.toUpperCase(),
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async loadStatoCivile() {
      let me = this;
      try {
        const responseStatoCivile = await UtilService.statoCivile();
        responseStatoCivile.data.data.forEach((element) => {
          me.statoCivileOptions.push({
            value: element,
            text: element.descrizione.toUpperCase(),
          });
        });
      } catch (e) {
        e;
      }
    },
    async getSelectedProvinciaResidenza(provinciaResidenza = null) {
      let me = this;
      if(provinciaResidenza!=null){
        me.jsonData.provinciaResidenza = provinciaResidenza.provincia;
        me.jsonData.codIstatProvinciaResidenza = provinciaResidenza.codIstat;
        me.comuniResidenzaOptions = [];
        try {
          const responseProvinciResidenza = await UtilService.listaComuni(provinciaResidenza.codIstat.toString());
          if (responseProvinciResidenza != null) {
            responseProvinciResidenza.data.data.forEach((element) => {
              me.comuniResidenzaOptions.push({
                value: element,
                text: element.nome.toUpperCase(),
              });
            });
          } else {
            me.comuniResidenzaOptions = [{value: null, text: "Seleziona il comune", disabled: true}];
          }
        } catch (e) {
          me.isLoading = false;
          e;
        }
      }
    },
    async controlloNazionalita() {
      let me = this;
      console.log(me.jsonData.assistito);
      if (me.jsonData.istatCittadinanza !== 100) me.nazionalitaStraniera = true;
      try {
        const responseNazioni = await UtilService.listaNazioni();
        responseNazioni.data.data.forEach((element) => {
          me.cittadinanzaOptions.push({
            value: element,
            text: element.descrizione.toUpperCase(),
          });
          me.cittadinanzaOptions.sort(function (a, b) {
            if (a.text < b.text) return -1;
            if (a.text > b.text) return 1;
            return 0;
          });
        });
      } catch (e) {
        me.isLoading = false;
        e;
      }
    },
    async onModifica() {
      let me = this;
      me.isLoading = true;
      const datiRegistrazione = {
        codiceFiscale: me.jsonData.assistito.codiceFiscale,
        codiceTS: me.jsonData.assistito.codiceTS,
        nome: me.jsonData.assistito.nome,
        cognome: me.jsonData.assistito.cognome,
        dataNascita: me.jsonData.assistito.dataNascita,
        sesso: me.jsonData.assistito.sesso,
        scadenzaTS: me.jsonData.assistito.scadenzaTS,
        luogoDiNascita: me.jsonData.assistito.luogoDiNascita,
        istatLuogoDiNascita: me.jsonData.assistito.istatLuogoDiNascita,
        statoCivile: me.jsonData.assistito.statoCivile.descrizione,
        codStatoCivile: me.jsonData.assistito.statoCivile.id,
        provinciaResidenza: me.jsonData.assistito.residenza.provincia.provincia,
        codIstatProvinciaResidenza: me.jsonData.assistito.residenza.provincia.codIstat,
        comuneResidenza: me.jsonData.assistito.residenza.comune.nome,
        codIstatComuneResidenza: me.jsonData.assistito.residenza.comune.codice,
        provinciaResidenzaSigla: me.jsonData.assistito.residenza.comune.provinciaSigla,
        strutturaPreferita: "140000",
        istatCittadinanza: me.cittadinanzaScelta.codice ?? me.cittadinanzaScelta.value,
        indirizzoResidenza: me.jsonData.assistito.indirizzoResidenza,
        capResidenza: me.jsonData.assistito.residenza.comune.cap,
        cittadinanza: this.cittadinanzaScelta.descrizione?? me.cittadinanzaScelta.text,
        terminiServizio: me.jsonData.assistito.terminiServizio,
        numeroCellulare: me.jsonData.assistito.numeroCellulare,
        numeroFisso: me.jsonData.assistito.numeroFisso,
        codiceNazionalita: me.cittadinanzaScelta.codice ?? me.cittadinanzaScelta.value,
        controlloStep3: true,
        controlloStep1: true,
        controlloStep2: true,
      };
      try {
        const responseModificaAssistito = await AuthService.modificaAnagraficaUtente(datiRegistrazione);
        if (responseModificaAssistito.data.stato === 200 || responseModificaAssistito.data.stato === 201) {
          me.isLoading = false;
          if(responseModificaAssistito.data.errore){
            this.$bvModal
                .msgBoxOk(responseModificaAssistito.data.errore, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {
                  me.isLoading = false;
                })
                .catch((err) => {
                  me.isLoading = false;
                  console.log(err);
                });
            return
          }
          this.$bvModal
              .msgBoxOk(responseModificaAssistito.data.data.messaggioSuccessoRegistrazione, {
                title: "Utente Modificato",
                size: "md",
                okVariant: "outline-success",
                headerClass: "vv-msg-header-success",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
                me.$emit("saveEdit");
                me.isLoading = false;
              })
              .catch((err) => {
                me.isLoading = false;
                console.log(err);
              });
        } else {
          me.isLoading = false;
          this.$bvModal
              .msgBoxOk(responseModificaAssistito.data.errore, {
                title: "Errore",
                size: "md",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
                me.isLoading = false;
              })
              .catch((err) => {
                me.isLoading = false;
                console.log(err);
              });
          me.isLoading = false;
        }
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
            .msgBoxOk(e, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch(() => {
              me.isLoading = false;
            });
      }
    },
    onIndietro() {
      let me = this;
      me.$emit("saveEdit");
    },
  },
};
</script>
